import React, { Component } from 'react';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import {connect} from 'react-redux';
import PropTypes from "prop-types";

const props = {
  zDepth: 0,
  style: {
    borderBottom: '1px solid #c8ceda',
    margin: '0px'
  }
}


const CardSecction = ({icon, title, text}) => (
  <Card {...props}>
    <CardHeader titleColor='#1d3767' textStyle={{marginTop: 3}} style={{padding: '16px 0'}}
      avatar={<i className="material-icons no-padding">{icon}</i>}
      title={<span>{title}</span>}
      actAsExpander={true}
      showExpandableButton={false}
    />
    <CardText expandable={true}>
     {text}
    </CardText>
  </Card>
)


class sectionFaqs extends Component {
    static contextTypes = {
      router: PropTypes.object
    }
  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].faqs
    return (
      <div className="container-fluid">

          <section className="section-text row">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h1 className="h3 heavy">{langPlace.title}</h1>
                </div>

                <div className="col-md-12">

                  <CardSecction icon="airline_seat_recline_extra" title={langPlace.plazasTit} text={
                      <div><p>{langPlace.plazasP}</p>
                      <ul>
                        {langPlace.plazasText.map((txt, index) => <li key={index}>{txt}</li>)}
                      </ul></div>
                  }/>
                  <CardSecction icon="directions_boat" title={langPlace.reservaTit} text={<p>{langPlace.reservaText}</p>}/>
                  <CardSecction icon="card_travel" title={langPlace.documentacionTit} text={
                      <ul>
                        {langPlace.documentacionText.map((txt, index) => <li key={index}>{txt}</li>)}
                      </ul>
                  }/>
                  <CardSecction icon="contacts" title={langPlace.targetaTit} text={langPlace.targetaText}/>
                  <CardSecction icon="group" title={langPlace.pasajeros} text={
                    <ul>
                      <li>{langPlace.any}</li>
                      <li>
                        <ul>
                          {langPlace.anylist.map((txt, index) => <li key={index}>{txt}</li>)}
                        </ul>
                      </li><br/>
                      <li>{langPlace.sesenta}</li>
                      <li>
                        <ul>
                          {langPlace.sesentalist.map((txt, index) => <li key={index}>{txt}</li>)}
                        </ul>
                      </li><br/>
                      <li>{langPlace.seis}</li>
                    </ul>
                  }/>
                </div>

              </div>
            </div>
          </section>

      </div>
    );
  }
}

export default connect(
  (state) => ({settings: state.settings})
)(sectionFaqs)



// WEBPACK FOOTER //
// ./src/shared/routes/routeFaqs/pageFaqs.js